export default __webpack_public_path__ + "static/media/H4007.1.929e36e5.mp3";